import { TreatmentsTimelineModel } from 'src/pages/main/Journey/model';

class AnalysesTimelineModel extends TreatmentsTimelineModel {
  id = 'AnalysesTimelineModel';
}

const model = new AnalysesTimelineModel();
export default model;

